var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.open),expression:"open"}],staticClass:"_popup",style:({
      width: _vm.width ? _vm.width + 'px' : '',
      position: _vm.isFixed ? 'fixed' : 'absolute',
      top: _vm.position.top + 'px',
      left: _vm.position.left + 'px',
      bottom: _vm.position.bottom + 'px',
      right: _vm.position.right + 'px',
      zIndex: _vm.zIndex,
      border: _vm.border,
      borderColor: _vm.borderColor,
      borderRadius: _vm.borderRadius + 'px',
    })},[(_vm.needModal)?_c('div',{staticClass:"_popup_modal",on:{"click":function($event){return _vm.$emit('modal')}}}):_vm._e(),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }